import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aero-admin',
  templateUrl: './aero-admin.component.html',
  styleUrls: ['./aero-admin.component.css']
})
export class AeroAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
